const sublinks = document.querySelectorAll('.sublink-click');


if (sublinks != null) {
    sublinks.forEach((item) => {
        item.addEventListener('click', (event) => {
            var openedItem = document.querySelector('.open-list');
            if (item.parentElement.classList.contains('open-list')) {
                item.parentElement.classList.remove('open-list');
            } else if (openedItem != null) {
                openedItem.classList.remove('open-list');
                item.parentElement.classList.add('open-list');
            } else {
                item.parentElement.classList.add('open-list');
            }
        })
    });
}

const mainlink = document.querySelector('.main-link-mobile');

if (mainlink != null) {
    mainlink.addEventListener('click', (event) => {
        mainlink.parentElement.classList.toggle('open-main');
    })
}
